//#region src/js/templates/product.js
document.addEventListener("DOMContentLoaded", function() {
	function isIE() {
		const ua = window.navigator.userAgent;
		const msie = ua.indexOf("MSIE ");
		const trident = ua.indexOf("Trident/");
		return msie > 0 || trident > 0;
	}
	if (!isIE()) return;
	const hiddenInput = document.querySelector("#{{ product_form_id }} input[name=\"id\"]");
	const noScriptInputWrapper = document.createElement("div");
	const variantSwitcher = document.querySelector("variant-radios[data-section=\"{{ section.id }}\"]") || document.querySelector("variant-selects[data-section=\"{{ section.id }}\"]");
	noScriptInputWrapper.innerHTML = document.querySelector(".product-form__noscript-wrapper-{{ section.id }}").textContent;
	variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;
	document.querySelector("#Variants-{{ section.id }}").addEventListener("change", function(event) {
		hiddenInput.value = event.currentTarget.value;
	});
	const productUrl = document.querySelector("[data-product-url]").dataset.productUrl;
	const sectionId = document.querySelector("[data-section-id]").dataset.sectionId;
	const variantId = document.querySelector("[data-variant-id]").dataset.variantId;
	fetch(`${productUrl}?section_id=${sectionId}&variant=${variantId}`).then((response) => response.text()).then((responseText) => {
		const updatedHtml = new DOMParser().parseFromString(responseText, "text/html");
		const currentCartQuantity = document.querySelector(`#CartQuantity-${sectionId}`);
		currentCartQuantity.innerHTML = updatedHtml.querySelector(`#CartQuantity-${sectionId}`).innerHTML;
	});
});
if (!customElements.get("show-more-button")) customElements.define("show-more-button", class ShowMoreButton extends HTMLElement {
	constructor() {
		super();
		this.querySelector("button").addEventListener("click", (event) => {
			this.expandShowMore(event);
			const nextElementToFocus = event.target.closest(".parent-display").querySelector(".show-more-item");
			if (nextElementToFocus && !nextElementToFocus.classList.contains("hidden") && nextElementToFocus.querySelector("input")) nextElementToFocus.querySelector("input").focus();
		});
	}
	expandShowMore(event) {
		const parentDisplay = event.target.closest("[id^=\"Show-More-\"]").closest(".parent-display");
		this.querySelectorAll(".label-text").forEach((element) => element.classList.toggle("hidden"));
		parentDisplay.querySelectorAll(".show-more-item").forEach((item) => item.classList.toggle("hidden"));
		if (!this.querySelector(".label-show-less")) this.classList.add("hidden");
	}
});
document.addEventListener("DOMContentLoaded", () => {
	const stickyBar = document.getElementById("sticky-atc-bar");
	const productFormButtons = document.querySelector(".product-form__buttons");
	const stickyTrigger = document.getElementById("sticky-atc-trigger");
	const mainSubmitBtn = document.querySelector(".product-form__submit");
	console.log(stickyBar, productFormButtons);
	if (!stickyBar || !productFormButtons) return;
	new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const aboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
			stickyBar.classList.toggle("translate-y-full", !aboveViewport);
			stickyBar.classList.toggle("translate-y-0", aboveViewport);
			stickyBar.setAttribute("aria-hidden", String(!aboveViewport));
			stickyBar.inert = !aboveViewport;
		});
	}, { threshold: 0 }).observe(productFormButtons);
	if (mainSubmitBtn && stickyTrigger) {
		const syncState = () => {
			stickyTrigger.disabled = mainSubmitBtn.disabled;
		};
		syncState();
		new MutationObserver(syncState).observe(mainSubmitBtn, {
			attributes: true,
			attributeFilter: ["disabled"]
		});
		stickyTrigger.addEventListener("click", () => mainSubmitBtn.click());
	}
});
//#endregion
